import React, { useState, useEffect } from 'react';
import { ColorPickerInput } from '@common_components/inputs/color_picker/colorPickerInput.component';
import { ColorIcon } from '@common_components/icons/color.icon';
import { ToggleButton } from '@umanforge/common';

interface ButtonSelectThemeColorProps {
  label?: string;
  className?: string;
  disable?: boolean;
  labelPosition?: 'top' | 'left';
  textSize?: string;
  defaultValue?: string;
  onSelectionChange: ( selectedColor: string ) => void;
}

const ButtonSelectThemeColor: React.FC<ButtonSelectThemeColorProps> = ( {
  label = '',
  disable,
  className = '',
  labelPosition = 'left',
  textSize = 'w-3/12 mr-4',
  defaultValue = '',
  onSelectionChange,
} ) => {
  const colors = [
    '#f87171', '#60a5fa', '#34d399', '#facc15',
    '#c084fc', '#f472b6', '#818cf8'
  ];

  const [ selectedColor, setSelectedColor ] = useState<string>( defaultValue );
  const [ customInputColor, setCustomInputColor ] = useState<boolean>(
    defaultValue ? !colors.includes( defaultValue ) : false
  );

  useEffect( () => {
    setSelectedColor( defaultValue );
    setCustomInputColor( !colors.includes( defaultValue ) );
  }, [] );

  const handleButtonClick = ( color: string ) => {
    const newColor = selectedColor === color ? '' : color;
    setCustomInputColor( false );
    if ( newColor !== selectedColor ) {
      setSelectedColor( newColor );
      onSelectionChange( newColor );
    }
  };

  const handleColorPickerChange = ( color: string ) => {
    setCustomInputColor( true );
    if ( color !== selectedColor ) {
      setSelectedColor( color );
      onSelectionChange( color );
    }
  };

  return (
    <>
      {
        !disable ?
          <div
            className={`
              w-full
              ${ className }
              ${labelPosition === 'left' ? 'flex-center' : ''}
            `}
          >
            {label && (
              <label className={`text-gray-600 ${textSize} flex`}>
                <ColorIcon size={5}/>
                <p>{label}</p>
              </label>
            )}
            <div className="flex gap-2 items-center">
              {colors.map( ( color, index ) => {return (
                <div key={index} className='flex w-fit h-fit'>
                  <ToggleButton
                    seeCheck
                    bgColor={color}
                    HasOneSelected={selectedColor !== ''}
                    textColor={color}
                    isSelected={selectedColor === color}
                    onClick={() => {return handleButtonClick( color );}}
                  />
                </div>
              );} )}
              <div>
                <ColorPickerInput
                  onChange={handleColorPickerChange}
                  color={customInputColor ? selectedColor : ''}
                  className='text-gray-600'
                />
              </div>
            </div>
          </div>
          :
          <div className='flex w-full justify-center'>
            <ColorPickerInput
              disable
              labelPosition={ labelPosition }
              label={ label }
              onChange={handleColorPickerChange}
              color={selectedColor}
              className='text-gray-600'
            />
          </div>
      }
    </>
  );
};

export default ButtonSelectThemeColor;
